import { Fragment } from "react";
import { BusienssControlNames, GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import CreateAttributeList, { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import  { getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { ResizeableType, WBComponent } from "./WBComponent";
import { NodeCSSClassDefinition } from "./NodeGlobalStyleGenerator";

export default class BlogSearch extends WBComponent {

    constructor() {
        super();
        this.typename = wBComponentTypeNames.blogSearch;
        this.displayName = "Blog Search";
        this.dropList = defaultDropList;
        this.primaryEditAttributes = [];
        this.colorFields = ["blog-search-outline"];
        this.editList = [...this.colorFields,...this.primaryEditAttributes, ...CreateAttributeList(true, true, false, true, false,false,false)];
    

        this.cssDefinitions =[
            new NodeCSSClassDefinition("input",
            [
                {key:"blog-search-outline",cssProperty:"border-color",default:""},
              
                
             ]),
           
            ]
        this.resizeType = ResizeableType.All;
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" height="1em"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [
            new AttributeDefinition("blog-search-outline","Outline","", AttributeInputType.ColorField),

        ]
    }





    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, siteData.businessId);
        const atts = GetNodeDomAttributes("max-100 v-b-search", component, screenSize, isEditor);
        const layout = "1";
        if (!isEditor) {
            return <BusinessPlaceHolder node={component} dataKey={BusienssControlNames.blogSearch} layout={layout} classNames={atts.className} />
        }
        return (
            <Fragment>
                <style>{super.GetComponentGlobalCSS(component,true)}</style>
                <div {...atts}>
                    <GenericBusinessControl key={component.id + bid} bLocationId={bid} layout={layout} dataKey={BusienssControlNames.blogSearch} node={component} userContext={siteData} />
                </div>
            </Fragment>
        )
    }
}
